const getTypedObjectKeys = Object.keys as <T extends object>(object: T) => (keyof T)[];

export default getTypedObjectKeys;
